var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _g2, _g3, _g4, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132 132",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5fcff",
    d: "M0 0h132v132H0z",
    className: "colorf5fcff svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7f1ff",
    d: "M84 119c0-1.7 1.4-3.2 3.2-3.2h11.6c.9 0 1.5-.7 1.5-1.5v-.1c0-.8-.7-1.5-1.5-1.5h-4.1c-1.1 0-2-1-1.9-2.1.1-1 1-1.7 2-1.7h18.7c.9 0 1.7-.8 1.5-1.8-.1-.8-.8-1.3-1.6-1.3H91.7c-1.7 0-3-1.4-3-3 0-1.7 1.4-3 3-3h34.1c1.5 0 2.7 1.2 2.6 2.8-.1 1.4-1.3 2.5-2.8 2.5h-3.2c-.5 0-.9.2-1.2.5-.3.3-.5.7-.5 1.2 0 .9.8 1.7 1.7 1.7h5c1.1 0 1.9 1 1.7 2.1-.1.9-1 1.5-1.8 1.5h-16.9c-1.3 0-2.4 1.1-2.3 2.4.1 1.2 1.2 2.2 2.4 2.2H121c1.3 0 2.4 1.1 2.4 2.5-.1 1.3-1.2 2.2-2.5 2.2h-4.2c-.9 0-1.6.6-1.8 1.4-.2 1.1.6 2 1.7 2h8c.7 0 1.4.3 1.9.8s.8 1.1.8 1.9c0 1.4-1.2 2.6-2.6 2.6L90 130c-.6 0-1.1-.2-1.5-.6-.4-.4-.6-.9-.6-1.5 0-1.2 1-2.2 2.2-2.2h5.8c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7h-8.6c-.9 0-1.7-.4-2.2-.9-.8-.7-1.1-1.5-1.1-2.4zM2.9 21.3c0-1.7 1.4-3.2 3.2-3.2h11.6c.9 0 1.5-.7 1.5-1.5v-.1c0-.8-.7-1.5-1.5-1.5h-4.1c-1.1 0-2-1-1.9-2.1.1-1 1-1.7 2-1.7h18.7c.9 0 1.7-.8 1.5-1.8-.1-.8-.8-1.3-1.6-1.3H10.6c-1.7 0-3-1.4-3-3 0-1.7 1.4-3 3-3h34.1c1.5 0 2.7 1.2 2.6 2.8-.1 1.4-1.3 2.5-2.8 2.5h-3.2c-.5 0-.9.2-1.2.5-.3.3-.5.7-.5 1.2 0 .9.8 1.7 1.7 1.7h5c1.1 0 1.9 1 1.7 2.1-.1.9-1 1.5-1.8 1.5H29.3c-1.3 0-2.4 1.1-2.3 2.4.1 1.2 1.2 2.2 2.4 2.2h10.5c1.3 0 2.4 1.1 2.4 2.5-.1 1.3-1.2 2.2-2.5 2.2h-4.2c-.9 0-1.6.6-1.8 1.4-.2 1.1.6 2 1.7 2h8c.7 0 1.4.3 1.9.8s.8 1.1.8 1.9c0 1.4-1.2 2.6-2.6 2.6H9c-.6 0-1.1-.2-1.5-.6-.5-.6-.8-1.2-.8-1.8 0-1.2 1-2.2 2.2-2.2h5.8c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7H6.1c-.9 0-1.7-.4-2.2-.9-.6-.6-1-1.4-1-2.2z",
    className: "colord7f1ff svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M28.9 65.3h18.2v5.9H28.9z",
    className: "colorfff svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0e6ff",
    d: "M47.1 71.7H28.9c-.3 0-.5-.2-.5-.5v-5.9c0-.3.2-.5.5-.5h18.2c.3 0 .5.2.5.5v5.9c0 .3-.2.5-.5.5zm-17.7-1h17.2v-4.9H29.4v4.9z",
    className: "colorc0e6ff svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M23.3 55.5h23.8v5.9H23.3z",
    className: "colorfff svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0e6ff",
    d: "M47.1 61.8H23.3c-.3 0-.5-.2-.5-.5v-5.9c0-.3.2-.5.5-.5h23.8c.3 0 .5.2.5.5v5.9c0 .3-.2.5-.5.5zm-23.3-1h22.8V56H23.8v4.8z",
    className: "colorc0e6ff svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M107.4 62h10.3v5.2h-10.3z",
    className: "colorfff svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0e6ff",
    d: "M117.7 67.7h-10.3c-.3 0-.5-.2-.5-.5V62c0-.3.2-.5.5-.5h10.3c.3 0 .5.2.5.5v5.2c0 .3-.3.5-.5.5zm-9.8-1h9.3v-4.2h-9.3v4.2z",
    className: "colorc0e6ff svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M107.4 53.2h13.4v5.2h-13.4z",
    className: "colorfff svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0e6ff",
    d: "M120.8 59h-13.4c-.3 0-.5-.2-.5-.5v-5.2c0-.3.2-.5.5-.5h13.4c.3 0 .5.2.5.5v5.2c0 .2-.2.5-.5.5zm-12.9-1h12.4v-4.2h-12.4V58z",
    className: "colorc0e6ff svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M61.1 55.5c-.5.4-1.2.4-1.4.1L27.3 13c-.3-.4-.1-1 .4-1.4.5-.4 1.2-.4 1.4 0l32.3 42.5c.4.4.2 1-.3 1.4z",
    className: "colorfff svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0e6ff",
    d: "M107.4 36.3V117c0 .8-.6 1.4-1.4 1.4H46.4c-.8 0-1.4-.6-1.4-1.4V36.3c0-.8.6-1.4 1.4-1.4H106c.8 0 1.4.6 1.4 1.4z",
    className: "colorc0e6ff svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M49.2 39.2h53.9v75H49.2z",
    className: "colorfff svgShape"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0d7ff",
    d: "M80.7 32.8c0-2.5-2-4.5-4.5-4.5s-4.5 2-4.5 4.5h-6.6c-.6 0-1.1.5-1.1 1.1v5.9c0 .6.5 1.1 1.1 1.1h22.2c.6 0 1.1-.5 1.1-1.1v-5.9c0-.6-.5-1.1-1.1-1.1h-6.6z",
    className: "colora0d7ff svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.2,
    cy: 32.8,
    r: 2,
    fill: "#ffffff",
    className: "colorfff svgShape"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbaaf9",
    d: "M126.7 29.2c.3.7-.3 1.7-1.6 2.9-1.1 1-2.5 1.8-3.9 2.3l-23.9 9.2c-1.2.5-2.5.7-3.8.8l-8.1.2-.3-1 8.3-4.7 25.7-9.9c1.4-.5 2.9-.9 4.5-.9 1.7 0 2.8.3 3.1 1.1z",
    className: "colorcbaaf9 svgShape"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fee459",
    d: "m97.9 30.9 12.1 1.6-9.4 3.7-6.5-3.9zM92.6 39.4l-10.1-5-2.2.8 6.6 7.4z",
    className: "colorfee459 svgShape"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fee459",
    d: "m97.9 30.9 12.1 1.6-9.4 3.7-6.5-3.9zM113.5 35.2l-3.2 4-2.6 3.4-3.7 4.8-3.8 1.5 3.3-9.9z",
    className: "colorfee459 svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m86.7 49.3 6.9-8.1-6.1 2.4-3 6.6z",
    className: "colorfff svgShape"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fee459",
    d: "m86.7 49.3 6.9-8.1-6.1 2.4-3 6.6z",
    className: "colorfee459 svgShape"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa573",
    d: "M84.3 55.6c0 4.5-3.6 8.1-8.1 8.1s-8.1-3.6-8.1-8.1 3.6-8.1 8.1-8.1c4.4 0 8.1 3.6 8.1 8.1z",
    className: "colorffa573 svgShape"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m81.3 57.4-.9 1.6c-.1.1-.3.2-.4.1l-2.6-1.5v3c0 .2-.1.3-.3.3h-1.8c-.2 0-.3-.1-.3-.3v-3l-2.6 1.5c-.1.1-.3 0-.4-.1l-.9-1.5c-.1-.1 0-.3.1-.4l2.5-1.4-2.5-1.4c-.1-.1-.2-.3-.1-.4l.9-1.5c.1-.1.3-.2.4-.1l2.6 1.5v-3c0-.2.1-.3.3-.3h1.8c.2 0 .3.1.3.3v3l2.6-1.5c.1-.1.3 0 .4.1l.9 1.5c.1.1 0 .3-.1.4l-2.5 1.4 2.5 1.4c.1 0 .1.2.1.3z",
    className: "colorfff svgShape"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fee459",
    d: "M68.1 15.5c-1-.2-2.1 0-3 .7-1.3 1-1.8 2.8-1.3 4.3-2.1-1-4.6-.8-6.5.7-2.4 1.8-3.2 5.1-1.9 7.7-3.7-1-8.1-.1-11.7 2.6C40 34.3 38 38.3 38 42.1c-2.2-1.9-5.5-2.1-8-.2-1.9 1.5-2.8 3.9-2.4 6.1-1.3-1-3.1-1-4.5 0-.9.7-1.4 1.7-1.5 2.7-4.8-10.7-2.7-23.4 5.3-32.1 1.1-1.2 2.7-2.6 4.1-3.7 1.4-1.1 3.2-2.2 4.7-3C46.3 6.6 59.1 8 68.1 15.5z",
    className: "colorfee459 svgShape"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M63.8 20.5c-2.1-1-4.6-.8-6.5.7-2.4 1.8-3.2 5.1-1.9 7.7 0 0-13.9-18.3-24.2-13.9 1.4-1.1 3.2-2.2 4.7-3 .3-.2 12-4.8 27.9 8.5zM27.6 48c-.4-2.2.5-4.6 2.4-6.1 2.4-1.8 5.7-1.7 8 .2 0 0-13.9-18.3-6.9-27.1-1.4 1.1-3 2.5-4.1 3.7-.3.4-7.9 10.4.6 29.3z",
    className: "colorfff svgShape"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4e051",
    d: "M55.7 68.7h6.7v6.7h-6.7z",
    className: "colorb4e051 svgShape"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M58.1 74c-.1 0-.2 0-.3-.1l-1-.9c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l.6.5 2.5-2.5c.2-.2.5-.2.7 0s.2.5 0 .7l-2.8 2.8c-.1.1-.3.2-.4.2z",
    className: "colorfff svgShape"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4e051",
    d: "M55.7 79.1h6.7v6.7h-6.7z",
    className: "colorb4e051 svgShape"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M58.1 84.5c-.1 0-.2 0-.3-.1l-.9-.8c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l.6.5 2.5-2.5c.2-.2.5-.2.7 0s.2.5 0 .7l-2.8 2.8c-.2 0-.4.1-.5.1z",
    className: "colorfff svgShape"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4e051",
    d: "M55.7 89.5h6.7v6.7h-6.7z",
    className: "colorb4e051 svgShape"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M58.1 94.8c-.1 0-.2 0-.3-.1l-.9-.8c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l.6.5 2.5-2.5c.2-.2.5-.2.7 0s.2.5 0 .7l-2.8 2.8c-.2.1-.4.1-.5.1zM107.4 121.5c-17.9-8.4-15.2-31.4-15.2-31.4 10.5 0 15.2-5.5 15.2-5.5s4.8 5.4 15.2 5.5c0 0 2.7 23-15.2 31.4z",
    className: "colorfff svgShape"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4e051",
    d: "M107.4 117.8c-11-6.1-12.2-19-12.1-24.6 5.8-.6 9.8-2.7 12.1-4.3 2.3 1.6 6.3 3.7 12.1 4.3.1 5.6-1.1 18.5-12.1 24.6z",
    className: "colorb4e051 svgShape"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1ec95",
    d: "M107.4 91.5c2.3 1.4 5.6 2.9 9.9 3.6-.2 5.4-1.9 15-9.9 20.2V91.5z",
    className: "colord1ec95 svgShape"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#a06ff3",
    d: "M112.4 84.6c-.3 0-.5-.2-.5-.5v-2.3c0-.3.2-.5.5-.5s.5.2.5.5v2.3c0 .2-.3.5-.5.5zM112.4 80.3c-.3 0-.5-.2-.5-.5V51.5H110c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2.3c.3 0 .5.2.5.5v28.8c.1.3-.2.5-.4.5z",
    className: "colora06ff3 svgShape"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9cc8f4",
    className: "color9cc8f4 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.4 19.5h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.3.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 21.4c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4 19.5h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.3.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 21.4c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4 19.5h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.3.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 21.4c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4 19.5h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.3.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 21.4c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#9cc8f4",
    className: "color9cc8f4 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.6 67.7h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7 69.6c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6 67.7h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7 69.6c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6 67.7h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7 69.6c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6 67.7h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7 69.6c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#9cc8f4",
    className: "color9cc8f4 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.4 83.4h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 85.3c-.3 0-.5-.2-.5-.5V81c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.4 83.4h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 85.3c-.3 0-.5-.2-.5-.5V81c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.4 83.4h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 85.3c-.3 0-.5-.2-.5-.5V81c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.4 83.4h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 85.3c-.3 0-.5-.2-.5-.5V81c0-.3.2-.5.5-.5s.5.2.5.5v3.8c0 .3-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#9cc8f4",
    className: "color9cc8f4 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2 22.6h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3 24.5c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5V24c0 .2-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2 22.6h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3 24.5c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5V24c0 .2-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2 22.6h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3 24.5c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5V24c0 .2-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2 22.6h-3.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3 24.5c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5V24c0 .2-.2.5-.5.5z",
    fill: "#000000",
    className: "color000 svgShape"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m49.2 81.9-.1 17.6c0 1.4-1.1 2.5-2.5 2.5H36.2c-1.4 0-2.5-1.1-2.5-2.5l.1-17.6c0-1.4 1.1-2.5 2.5-2.5l10.4.1c1.4-.1 2.5 1.1 2.5 2.4z",
    className: "colorfff svgShape"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m33.9 81.8-.1 17.6c0 1.4-1.1 2.5-2.5 2.5l-25.5-.1c-1.4 0-2.5-1.1-2.5-2.5l.1-17.6c0-1.4 1.1-2.5 2.5-2.5l25.5.1c1.4 0 2.5 1.2 2.5 2.5z",
    className: "colorfff svgShape"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa573",
    d: "M49.2 83.8v-1.9c0-1.4-1.1-2.5-2.5-2.5l-10.4-.1c-1.4 0-2.5 1.1-2.5 2.5v1.9l15.4.1z",
    className: "colorffa573 svgShape"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa573",
    d: "M33.9 83.7v-1.9c0-1.4-1.1-2.5-2.5-2.5l-25.5-.1c-1.4 0-2.5 1.1-2.5 2.5v1.9l30.5.1z",
    className: "colorffa573 svgShape"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0d7ff",
    d: "M35.2 84v1.5c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3V84c0-.7.6-1.3 1.3-1.3.7 0 1.3.5 1.3 1.3zm-.1 5.8v1.5c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3v-1.5c0-.7.6-1.3 1.3-1.3.8-.1 1.3.5 1.3 1.3zm0 5.7V97c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3v-1.5c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3z",
    className: "colora0d7ff svgShape"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m53.7 90-.1 17.6c0 1.4-1.1 2.5-2.5 2.5l-10.3-.1c-1.4 0-2.5-1.1-2.5-2.5l.1-17.6c0-1.4 1.1-2.5 2.5-2.5l10.4.1c1.4 0 2.5 1.1 2.4 2.5z",
    className: "colorfff svgShape"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m38.4 89.9-.1 17.6c0 1.4-1.1 2.5-2.5 2.5l-25.5-.1c-1.4 0-2.5-1.1-2.5-2.5l.1-17.6c0-1.4 1.1-2.5 2.5-2.5l25.5.1c1.4 0 2.5 1.1 2.5 2.5z",
    className: "colorfff svgShape"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbb99",
    d: "M53.7 91.8v-1.9c0-1.4-1.1-2.5-2.5-2.5l-10.4-.1c-1.4 0-2.5 1.1-2.5 2.5v1.9l15.4.1z",
    className: "colorfb9 svgShape"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbb99",
    d: "M38.4 91.8v-1.9c0-1.4-1.1-2.5-2.5-2.5l-25.5-.1c-1.4 0-2.5 1.1-2.5 2.5v1.9l30.5.1z",
    className: "colorfb9 svgShape"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0d7ff",
    d: "M39.7 92v1.5c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3V92c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3zm-.1 5.8v1.5c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3v-1.5c0-.7.6-1.3 1.3-1.3.8 0 1.3.6 1.3 1.3zm0 5.8v1.5c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3v-1.5c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3z",
    className: "colora0d7ff svgShape"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#175d8d",
    d: "M76.2 35.2c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5zm0-3.9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5c0-.9.7-1.5 1.5-1.5z",
    className: "color175d8d svgShape"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#175d8d",
    d: "M127.2 29c-.5-1.2-2.3-1.4-3.6-1.3-1.5 0-3.1.3-4.6.9l-9 3.5-12-1.6h-.3L93.9 32c-.2.1-.3.2-.3.4s.1.4.2.5l2.8 1.6h-7.7V34c0-.9-.7-1.6-1.6-1.6h-6.1c-.3-2.5-2.4-4.5-5-4.5s-4.7 2-5 4.5h-6.1c-.9 0-1.6.7-1.6 1.6v.5H47.2l-2.4-3.1c3.2-2.1 7-2.8 10.4-1.9.5.1.7-.4.6-.7-1.1-2.5-.4-5.5 1.8-7.1 1.7-1.3 4-1.6 6-.6.4.2.8-.2.7-.6-.5-1.3 0-2.8 1.1-3.7.8-.6 1.7-.8 2.6-.6.2 0 .5-.1.5-.3.1-.2 0-.5-.1-.6-10-8.5-24.9-9.8-36.7-1.3l-2.1-2.7c-.5-.6-1.4-.6-2.1 0-.4.3-.7.8-.8 1.2 0 .3 0 .6.2.9l2.1 2.8c-.9.8-2.4 2.2-2.5 2.4C18.4 27.3 16.3 40 21.2 51c.1.2.3.3.5.3h.1c.2 0 .4-.2.4-.5.1-.9.5-1.8 1.3-2.4 1.2-.9 2.7-.9 3.9-.1.4.2.8-.1.8-.5-.9-5.4 5.5-8.9 9.5-5.4.4.3.8 0 .8-.4 0-3.1 1.4-6.2 3.8-8.7l2.2 3v42.5h-8.1c-1 0-1.9.5-2.5 1.3-.5-.8-1.4-1.3-2.5-1.4H5.9c-1.8 0-3 1.4-3 3-.1 19.8-.1 17.4-.1 17.6 0 1.7 1.3 3 3 3h1.6v5c0 1.7 1.3 3 3 3l25.5.1c1 0 1.9-.5 2.5-1.3.1.2.2.3.4.5.6.6 1.3.9 2.1.9h3.7v6.5c0 1 .8 1.9 1.9 1.9h55.9c1.4 1.1 3.1 2.2 4.9 3h.4c18-8.5 15.6-31.7 15.5-31.9 0-.3-.2-.5-.5-.5-9.2 0-13.9-4.3-14.8-5.2V43.2l3.5-4.5 10-3.9c1.5-.6 2.9-1.4 4-2.4 1.5-1.4 2.1-2.5 1.8-3.4zm-31.9 3.4 2.7-1 10 1.4c-.9.4-6.4 2.5-7.3 2.8-.1-.1-5.5-3.2-5.4-3.2zm3 3 1.2.7-6.3 2.4-.3.2h-.7L88.9 37v-1.6h9.4zM85 44.7c.1.2.3.4.5.4h.8L84.1 50c-.1.2 0 .4.1.5.2.2.4.2.5.1l2.2-.9c.1 0 .1-.1.2-.1l4-4.7 2.4-.1c3-.1 4.6-1.2 8.3-2.5l-2.1 6.4c-.1.2 0 .4.1.5.1.1.2.1.4.1h.2l2.2-.9v38.8c-2.4 1.2-5.9 2.3-10.5 2.3-.3 0-.5.2-.5.5 0 0 0 .2-.1.6H65.9c-.3 0-.5.2-.5.5s.2.5.5.5h25.7c-.1 3.9.1 14 5.8 22H49.7v-3h1.4c1.7 0 3-1.4 3-3 0-1.8 0 6.5.1-17.7 0-1.6-1.3-3-3-3h-1.5V39.6h13.7v.1c0 .9.7 1.6 1.6 1.6h20.1l1 1.1-1.2.7c-.2.1-.3.4-.2.6l.3 1zm2.8-.7 4.1-1.6c-.1.1-5.6 6.6-5.5 6.5l-1 .4c.1-.1 2.6-5.6 2.4-5.3zM40 91.3c-.2-.4-.6-.8-1.1-1v-.4c0-.5.2-1 .6-1.4.4-.4.9-.6 1.4-.6l10.4.1c1.1 0 2 .9 2 2v1.4c-9.8-.1 2.7-.1-13.3-.1zm-2.5 13.8v-1.5c0-.4.4-.8.8-.8.5 0 .8.4.8.8v1.5c0 .5-.4.8-.8.8-.3 0-.8-.3-.8-.8zm.8-5c-.5 0-.8-.4-.8-.8v-1.5c0-.5.4-.8.8-.8.3-.1.8.3.8.8v1.5c0 .4-.4.8-.8.8zm-.7-6.6V92c0-.5.4-.8.8-.8s.8.3.8.8v1.5c0 .4-.4.8-.8.8-.5-.1-.8-.3-.8-.8zM8.4 91.1c.1-.4-.3-2 .6-2.7.4-.4.9-.5 1.3-.5l25.5.1c1.1 0 2 .9 2 2v.4c-.5.1-.9.5-1.1.9-14.7-.1-14.6-.1-28.3-.2zm24.7-7.2c0-.5.4-.8.8-.8s.8.3.8.8v1.5c0 .4-.3.8-.8.8-.5-.1-.8-.3-.8-.8v-1.5zm15.6.4V87h-7.8c-.8 0-1.5.3-2.1.9-.1.1-.3.3-.4.5-.5-.8-1.4-1.3-2.5-1.3h-1.1c.5-.3.8-.9.8-1.5v-1.2c1.4-.2-4.8-.2 13.1-.1zm32.5-48.9h2.2c.1 0 8.7 4.3 8.2 4l-.4.2L87 42c-.1-.1-6.2-7-5.8-6.6zm-16.7-1.5c0-.3.3-.6.6-.6h6.6c.3 0 .5-.2.5-.5 0-2.2 1.8-4 4-4s4 1.8 4 4c0 .3.2.5.5.5h6.6c.3 0 .6.3.6.6v2.6c-.1 0-4.6-2.3-4.3-2.1l-.9-.5c-.1-.1-.3-.1-.4 0l-1.3.5-.9.3c-.2.1-.3.2-.3.4v.3s0 .1.1.1c.1.1 4.6 5.2 4.3 4.8H65.1c-.3 0-.6-.3-.6-.6v-5.8zM49.3 9.2c6.1 0 12.2 1.9 17.3 5.8-.7.1-1.3.4-1.9.8-1.1.8-1.7 2.1-1.7 3.5-9.8-7.8-18-8.9-22.8-8.6 3-1 6.1-1.5 9.1-1.5zM36 12.5s0-.1 0 0c1-.4 11.3-4 25.6 6.9-1.7-.1-3.3.3-4.7 1.4-1.9 1.4-2.9 3.7-2.7 6-4.8-5.7-13.2-13.6-20.6-12.9.3-.2 1.3-.9 2.4-1.4zm-8.3.2v-.1c0-.1.1-.4.4-.5.2-.1.4-.2.5-.2.1 0 .2 0 .2.1l2.1 2.7h-.1c-.3.3-.7.5-1 .8l-2.1-2.8zm-4.9 34.9c-.6.4-1 1-1.3 1.6-3.4-8.8-2.3-18.7 2.9-26.5-1.6 4.6-2.6 12.7 2.2 24.2-1.3-.3-2.7-.1-3.8.7zm12.3-7.4s-.1 0 0 0c-1.9-.5-4.6.3-6.3 2.1-.4.4-.7.9-1 1.5-.2.2-.5 1.4-.6 1.8-6.5-16.3-.7-25.3.1-26.4v-.1c.1-.1.5-.6 2-2-2.9 7.6 3.9 18.9 6.9 23.4-.3-.1-.9-.3-1.1-.3zm2.5.5C33 34 26.5 21.9 31.4 15.4h.1c7.5-3 17.4 6.5 22.6 12.7-3.8-.5-8.3.7-11.7 3.8-2.5 2.2-4.4 5.4-4.8 8.8zm5.4-8c.3-.3.6-.6 1-.8h.1l2 2.6c-.5.1-.9.4-1.1.8l-2-2.6zm2.5 3.6v-.2c.1-.4.4-.7.8-.7h17.1v3.3H49.1c-.3 0-.4.2-.4.5v40.5c-.5-.5-1.2-.8-2-.8h-1.3c.1-11.3.1-32.6.1-42.6zm-9.1 43.6c.1 0 10.1.1 10.4.1 1.1 0 2 .9 2 2v1.4c-2.9 0-10.3-.1-13.2-.1-.2-.5-.6-.8-1.1-1v-.4c-.1-1.2.8-2 1.9-2zM3.9 81.7c0-.9.7-1.6.9-1.7.1-.1.5-.3 1-.3l25.5.1c.8 0 1.6.6 1.8 1.2.1.2.1.5.1.7v.4c-.5.1-1 .6-1.1 1L3.9 83v-1.3zm1.9 19.6c-1.1 0-2-.9-2-2L3.9 84l28.2.2v1.2c0 .6.3 1.2.8 1.5-13.2-.1-9.1 0-22.4-.1-1.6 0-3 1.3-3 3-.1 15.9-.1 10.4-.1 11.6l-1.6-.1zm30 8.2-25.5-.1c-1.1 0-2-.9-2-2 0-1.7 0 3.8.1-15.3l28.2.2v1.2c0 .9.6 1.5 1.3 1.7v.9c-.8.2-1.3.9-1.3 1.7v1.5c0 .8.5 1.5 1.3 1.7v.9c-.8.2-1.3.9-1.3 1.7v1.5c0 .9.6 1.5 1.3 1.7v.8c-.1 1-1 1.9-2.1 1.9zm5 0c-.5 0-1-.2-1.4-.6-.4-.4-.6-.9-.6-1.4v-.8c.8-.2 1.3-.9 1.3-1.7v-1.5c0-.7-.5-1.5-1.3-1.7v-.9c.8-.2 1.3-.9 1.3-1.7v-1.5c0-.9-.6-1.6-1.3-1.7v-.9c.8-.2 1.3-.9 1.3-1.7v-1.2c.1 0 9.8.1 13.1.1l-.1 15.3c0 1.1-.8 2-2 2 0 0-11-.1-10.3-.1zm5.6 8.4c-.5 0-.9-.4-.9-.9v-6.4h3.3v3.5c0 .3.2.5.5.5H98c.9 1.1 1.9 2.2 3 3.3H46.4zm75.8-27.4c.2 3.2 1 22.8-14.8 30.4-10.9-5.2-15.3-17.3-14.9-29.3 0-.4 0-.8.1-1v-.1c6.6-.1 11.7-2.4 14.8-5.2 3.1 2.9 8.2 5.1 14.8 5.2zm-15.3-6.1c-.3.3-1.4 1.3-3.3 2.4V48.1l.6-.2c.1 0 .2-.1.2-.2l2.5-3.2v39.9zM103.7 47c-.2.1-2.9 1.1-2.7 1 0-.1 3-9.2 2.8-8.6.1 0 8.6-3.3 8.1-3.1 0 .1-6.1 8-8.2 10.7zm21.1-15.4c-1.1 1-2.3 1.7-3.7 2.3l-8.5 3.3 1.3-1.7c.1-.2.1-.4 0-.6-.1-.2-.4-.2-.6-.2-.1 0-10.1 3.9-10 3.9-.1 0-.1.1-.2.1s-.1.1-.1.2-.8 2.4-.7 2.3c-4.5 1.6-5.8 2.6-8.7 2.7h-1.5l2-2.4c.3-.4-.1-1-.6-.8-6.3 2.5-6.3 2.3-6.4 2.6l-.4.7h-.9l-.1-.2c.1-.1 7.5-4.2 7.4-4.2 18.5-7.2-24.7 9.5 26.1-10.2 1.4-.5 2.9-.8 4.3-.8h1.1c-.4.4-1 .8-1.8 1.1-.3.1-.4.4-.3.6.1.2.3.4.5.4h.1c1.4-.4 2.2-1.3 2.6-1.8.2.1.3.2.4.4.3.5-.2 1.4-1.3 2.3z",
    className: "color175d8d svgShape"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#175d8d",
    d: "M76.2 47c-4.7 0-8.6 3.8-8.6 8.5s3.9 8.5 8.6 8.5c4.7 0 8.5-3.8 8.5-8.5.1-4.7-3.8-8.5-8.5-8.5zm0 16.1c-4.2 0-7.6-3.4-7.6-7.5 0-4.2 3.4-7.5 7.6-7.5 4.2 0 7.5 3.4 7.5 7.5.1 4.1-3.3 7.5-7.5 7.5zm-13.8 5.1h-6.7c-.3 0-.5.2-.5.5v6.7c0 .3.2.5.5.5h6.7c.3 0 .5-.2.5-.5v-6.7c0-.2-.2-.5-.5-.5zm-.5 6.7h-5.7v-5.7h5.7v5.7zm3.5-4.5c0 .3.2.5.5.5h30.8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H65.9c-.3 0-.5.2-.5.5zm.5 3.9h20.3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H65.9c-.3 0-.5.2-.5.5s.2.5.5.5zm-3.5 4.3h-6.7c-.3 0-.5.2-.5.5v6.7c0 .3.2.5.5.5h6.7c.3 0 .5-.2.5-.5v-6.7c0-.3-.2-.5-.5-.5zm-.5 6.7h-5.7v-5.7h5.7v5.7zm34.8-5.1H65.9c-.3 0-.5.2-.5.5s.2.5.5.5h30.8c.3 0 .5-.2.5-.5 0-.2-.3-.5-.5-.5zm-10.5 3.5H65.9c-.3 0-.5.2-.5.5s.2.5.5.5h20.3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM62.4 89h-6.7c-.3 0-.5.2-.5.5v6.7c0 .3.2.5.5.5h6.7c.3 0 .5-.2.5-.5v-6.7c0-.3-.2-.5-.5-.5zm-.5 6.6h-5.7V90h5.7v5.6zm4-.6h20.3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H65.9c-.3 0-.5.2-.5.5s.2.5.5.5zm41.2-6.6c-.1 0-.1.1-.2.1-3.4 2.3-7.5 3.7-11.7 4.1-.3 0-.5.2-.5.5-.1 10.1 3.5 20.1 12.4 25.1.1.1.3.1.5 0 11.3-6.3 12.4-19.6 12.4-25.1 0-.3-.2-.5-.5-.5-5.5-.6-9.4-2.5-11.7-4.1-.1 0-.1-.1-.2-.1-.1-.1-.3-.1-.5 0zm.8 1.4c2.4 1.5 6.1 3.2 11.1 3.8 0 5.4-1.3 17.3-11.1 23.3-.2.1-.3.2-.5.3-.2-.1-.3-.2-.5-.3-7.9-4.8-11.1-14.2-11.1-23.3 3.9-.5 7.7-1.7 11.1-3.8.2-.1.3-.2.5-.3.2.1.3.2.5.3zm-73.4 4.7H24.3c-.3 0-.5.2-.5.5s.2.5.5.5c23.6.1-3.4 0 10.2 0h.1c.2 0 .4-.2.4-.5 0-.2-.2-.5-.5-.5zm-23.5.9 10.6.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5L11 94.4c-.3 0-.5.2-.5.5s.2.5.5.5zm23.5 2.5h-4.7c-.3 0-.5.2-.5.5s.2.5.5.5h4.7c.3 0 .5-.2.5-.5v-.1c-.1-.2-.3-.4-.5-.4zm-17.7.4c0 .3.2.5.5.5l10.8.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5l-10.8-.1c-.3 0-.5.3-.5.5zm-5.8.5h4.8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H11c-.3 0-.5.2-.5.5s.2.5.5.5zm23.4 5.9-23.5-.1c-.2 0-.5.2-.5.5s.2.5.5.5l23.5.1c.3 0 .5-.2.5-.5 0-.2-.2-.5-.5-.5z",
    className: "color175d8d svgShape"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#a06ff3",
    d: "M35.5 50.7c-.3 0-.5-.2-.5-.5V48c0-.3.2-.5.5-.5s.5.2.5.5v2.3c0 .2-.2.4-.5.4zM39.1 74.3h-3.6c-.3 0-.5-.2-.5-.5V52.2c0-.3.2-.5.5-.5s.5.2.5.5v21.1h3.1c.3 0 .5.2.5.5s-.3.5-.5.5z",
    className: "colora06ff3 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.0c83ca9596be2a8a6f8678de7f25e3ef.svg";
export { ForwardRef as ReactComponent };